// extracted by mini-css-extract-plugin
export default {"table":"PeceK"};